import * as _ from 'lodash'
import * as React from 'react'
import Select from 'react-select'

import Icon from 'components/Icon'
import { UI } from 'Icon/ui'

import './Select.scss'

export interface SelectOptionItem {
  value: number | string
  label: string
  disabled?: boolean
}

interface SelectWrapperProps {
  name?: string
  id?: string
  options: SelectOptionItem[]
  value?: number | string
  onChange?: (value: SelectOptionItem) => void
  searchable?: boolean
  className?: string
}

interface SelectWrapperState {
  width: number
  mobileState: 'show' | ''
}

class SelectWrapper extends React.Component<
  SelectWrapperProps,
  SelectWrapperState
> {
  public oldProps: SelectWrapperProps

  constructor(props: SelectWrapperProps) {
    super(props)
    this.state = {
      width: window.innerWidth,
      mobileState: '',
    }
    this.oldProps = props
  }

  public componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  public UNSAFE_componentWillReceiveProps(newProps: SelectWrapperProps) {
    if (
      newProps.value === undefined ||
      (!_.isEqual(newProps.options, this.oldProps.options) &&
        !newProps.options.map(x => x.value).includes(newProps.value))
    ) {
      const [firstOption] = newProps.options
      if (newProps.onChange && firstOption) {
        newProps.onChange(firstOption)
      }
    }
    this.oldProps = newProps
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  public handleResize = () => {
    this.setState({ width: window.innerWidth })
  }

  public handleChange = (target: any) => {
    const { options, onChange } = this.props
    const { value } = target

    const option = options.find(x => `${x.value}` === `${value}`)
    if (onChange && option) {
      onChange(option)
    }
  }

  public render() {
    const { id, name, value, options, searchable, className = '' } = this.props
    const { width, mobileState } = this.state
    const arrowRenderer = () => <Icon icon={UI.chevronDown} />

    return width <= 500 ? (
      <select
        {...{ id, name, value }}
        className={'srprs-select' + ` ${mobileState} ${className}`}
        onChange={event => {
          this.handleChange(event.target)
          this.setState({ mobileState: '' })
        }}
        onFocus={() => this.setState({ mobileState: 'show' })}
        onBlur={() => this.setState({ mobileState: '' })}
      >
        {options.map(option => {
          return (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          )
        })}
      </select>
    ) : (
      <Select
        clearable={false}
        onChange={this.handleChange}
        {...{ className }}
        {...{ id, name, options, value, searchable, arrowRenderer }}
      />
    )
  }
}

export default SelectWrapper
